export default __webpack_public_path__ + "static/media/Mintmachine.d56e75bb.gif";